import { render, staticRenderFns } from "./mcq.vue?vue&type=template&id=6813da9a&"
import script from "./mcq.vue?vue&type=script&lang=js&"
export * from "./mcq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports